export default __webpack_public_path__ + "static/Cafe24Danjunghae.subset-b2fc3d14958062e5fde201235957cdd6.otf";